import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useAuthMethod, useAuthUser } from "@crema/utility/AuthHooks";
import { changeRoleLabel, convertToProperText } from "@crema/utility/Utils";

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 108,
        color:
            theme.palette.mode === "light"
                ? "rgb(55, 65, 81)"
                : theme.palette.grey[300],
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": {
            padding: "4px 0",
        },
        "& .MuiMenuItem-root": {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            "&:active": {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
}));

export default function ProfileSwitcher() {
    const { user } = useAuthUser();
    const role = changeRoleLabel(user.role);
    const { switchProfile } = useAuthMethod();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleProfileSwitch = (role) => {
        switchProfile(role);
    };

    return (
        <div>
            <Button
                id="profile-switcher-button"
                aria-controls={open ? "profile-switcher-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={
                    user.roles.length > 1 ? <KeyboardArrowDownIcon /> : false
                }
            >
                {convertToProperText(role)}
            </Button>
            {user.roles.length > 1 && (
                <StyledMenu
                    id="profile-switcher-menu"
                    MenuListProps={{
                        "aria-labelledby": "profile-switcher-button",
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    {user &&
                        user.roles.map((role) => {
                            const roleLabel = changeRoleLabel(role);
                            return (
                                user.role !== role && (
                                    <MenuItem
                                        key={role}
                                        onClick={() =>
                                            handleProfileSwitch(role)
                                        }
                                        disableRipple
                                    >
                                        {convertToProperText(roleLabel)}
                                    </MenuItem>
                                )
                            );
                        })}
                </StyledMenu>
            )}
        </div>
    );
}
